<div class="content d-flex flex-col justify-space-evenly bg-white w-100" [ngClass]="{ 'small-size': !scheduled, 'medium-size': scheduled }">
  <div class="header d-flex justify-space-between">
    <div class="title d-flex justify-space-between fz-12 lh-16">
      <span class="grey-60">{{ category }}</span>
      <svg *ngIf="priority"   width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#C7C7C7"/></svg>
      <span *ngIf="priority" class="red-50" i18n>Important</span>
    </div>
      <div class="grey-60">1s</div>
  </div>
  <ng-container *ngTemplateOutlet="textSkeleton"></ng-container>
  <div *ngIf="scheduled" class="grey-60 fz-14 lh-20 mt-4" i18n>Scheduled summary</div>
</div>

<ng-template #textSkeleton>
  <skeleton class="mt-4" [avatar]="{show: false}" [title]="{show: true, width: '200px', height: '12px', background: GREY_5}" [paragraph]="{ show: false }" [shouldShowAnimation]="false">
  </skeleton>
</ng-template>